import React from 'react';
import '../../styles/accessibility.css';

/**
 * Skip Navigation Links
 * Location: frontend/src/components/layout/SkipNav.js
 *
 * Provides keyboard users with the ability to skip repetitive navigation
 * and jump directly to main content or navigation menu.
 *
 * WCAG 2.1 Success Criterion 2.4.1: Bypass Blocks (Level A)
 *
 * Usage:
 * - Add this component at the very top of your app (before any other content)
 * - Ensure target elements have matching IDs (main-content, navigation)
 * - Links are hidden by default and appear when focused via Tab key
 */
const SkipNav = () => {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <a href="#navigation" className="skip-link">
        Skip to navigation
      </a>
      <a href="#search" className="skip-link">
        Skip to search
      </a>
    </>
  );
};

export default SkipNav;
